import get from 'lodash.get';

export const getXprops = () => {
  const initialXProps = get(global, 'xprops', null);
  return { ...checkBackwardCompatibility(initialXProps) };
};

export const checkBackwardCompatibility = (xprops: any) => {
  const {
    locale,
    targetIframe,
    checkoutRequestId,
    publicKey,
    onCreateTokenSucceeded,
    onCreateTokenError,
    onFinalizePayment,
    onErrorPayment,
    onGetInfoSuccess,
    config: configInProps,
    callbacks: callbacksInProps,
    options,
    ...rest
  } = xprops;
  const config = { locale, targetIframe, checkoutRequestId, publicKey, ...configInProps };
  const callbacks = {
    onCreateTokenSucceeded,
    onCreateTokenError,
    onFinalizePayment,
    onErrorPayment,
    onGetInfoSuccess,
    ...callbacksInProps,
  };
  return {
    config,
    callbacks,
    options: {
      button: {},
      paymentMethodInformation: {},
      ...options,
    },
    ...rest,
  };
};
